<template>
  <div class="container">
    <div class="columns is-centered">
      <div class="column">
        <h1>Application Submitted</h1>
        <div v-if="applicantId != null">
          <callout type="warning">
            Your application number is {{ applicantId }} -- Please make a note of it as you will need it in the future to check the status of your application. You should receive an email confirming your application submission within 1 hour. If you don't receive it, check your junk folder, then contact <a href="mailto:EvictionDiversionProgram@coraservices.org"><u>EvictionDiversionProgram@coraservices.org</u></a>.
          </callout>
          <callout type="info">
            Your application has been submitted. You can check it's status in the <a @click="goToStatus">Status Page</a>
          </callout>
        </div>
        <div v-else>
          <callout type="info">
            Your application has been successfully submitted.  You will receive an email that contains your applicant ID. Please make a note of it as you will need it in the future to check the status of your application here: <a href="Status">Status Page</a>. If you do not receive it, check your junk folder, then contact <a href="mailto:EvictionDiversionProgram@coraservices.org"><u>EvictionDiversionProgram@coraservices.org</u></a>.  
          </callout>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "LandlordSuccessPage",
  props: {
    applicantId: {
      default: null,
      type: String,
    },
  },
  methods:{
    goToStatus(){
      this.$router.push({
        name: "Status",
        params: { applicantId: this.applicantId },
      });
    },
  },
};
</script>